/* document.addEventListener("DOMContentLoaded", function () {
  const tabs = document.querySelectorAll(".tab-list__variants li");
  const contents = document.querySelectorAll(".tab-content__variants");
  const selectedSize = document.getElementById("selectedSize__variants");

  tabs.forEach((tab) => {
    tab.addEventListener("click", function () {
      tabs.forEach((innerTab) => innerTab.classList.remove("active"));
      contents.forEach((content) => content.classList.remove("active"));

      const target = tab.getAttribute("data-tab");
      tab.classList.add("active");
      document.getElementById(target).classList.add("active");
    });
  });

  contents.forEach((content) => {
    content.addEventListener("click", function (e) {
      if (e.target.tagName === "DIV") {
        selectedSize.style.display = "block";
        selectedSize.querySelector("span").textContent = e.target.textContent;
        contents.forEach((innerContent) => {
          innerContent.querySelectorAll("div").forEach((div) => {
            div.style.border = "1px solid rgb(235, 232, 221)";
            div.style.backgroundColor = "transparent";
          });
        });
        e.target.style.border = "1px solid black";
        e.target.style.backgroundColor = "rgb(235, 232, 221)";
      }
    });
  });

  // Select the first div in the first content as default
  const firstTab = document.querySelector(".tab-content__variants.active div");
  if (firstTab) {
    selectedSize.querySelector("span").textContent = firstTab.textContent;

    firstTab.style.border = "1px solid black";
    firstTab.style.backgroundColor = "rgb(235, 232, 221)";
  }
});*/



document.addEventListener('DOMContentLoaded', function(){
    var tabs = document.querySelectorAll('.tab-list__variants li');
    var contents = document.querySelectorAll('.tab-content__variants');

    tabs.forEach(function(tab, index) {
        tab.addEventListener('click', function() {
            tabs.forEach(function(innerTab) {
                innerTab.classList.remove('active');
            });
            tab.classList.add('active');

            contents.forEach(function(content) {
                content.classList.remove('active');
            });
            contents[index].classList.add('active');
        });
    });
});



